// One browser geolocation reading, for check-ins and "My location" in chats.
import { GEOLOCATION_OPTIONS, geolocationErrorText } from "./checkIns";

/** The browser gave no fix; the message says why. */
export class LocationUnavailable extends Error {}

export function currentPosition(): Promise<GeolocationPosition> {
  return new Promise((resolve, reject) => {
    if (!("geolocation" in navigator)) {
      reject(new LocationUnavailable("This browser can't share your location."));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      resolve,
      (error) => reject(new LocationUnavailable(geolocationErrorText(error.code))),
      GEOLOCATION_OPTIONS,
    );
  });
}
